import React from 'react'
// import { Link } from 'react-router-dom'

function CloudComputingServiceDetails() {
    return (
        <div>
            <div className="services-details-area default-padding">
                <div className="cotnainer">
                    <div className="row">
                        <div className="col-lg-10 offset-lg-1">
                            <div className="site-heading text-center">
                                <h4 className="sub-title">Website Development</h4>
                                <h1 className="title">Build a Website That Grows as Fast as Your Business</h1>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="container">
                    <div className="services-details-items">
                        <div className="row">
                            <div className="col-xl-12 services-single-content">
                                <div className="thumb mb-50">
                                    <img className="w-100" src="static/img/cloudcomputing/21.webp" alt="Thumb" title='Application Development' />
                                </div>
                                <p>
                                    At Microcode Software, we don't just build websites; we provide memorable digital experiences that attract your audience, drive results, and set you apart from the competition. We offer customized web development services that align with your vision and goals. As an affordable web design company in India, we help businesses of all sizes access premium development services without compromising on quality.

                                </p>
                                <h2>Advanced Web Development Services</h2>
                                <p>
                                    <strong>Custom Web Solutions:</strong> We create customized web solutions for your exact business needs. Whether it’s integrating with third-party tools, connecting internal systems, or workflow automation, we can create custom solutions to optimize operations, and improve your results.
                                </p>
                                <p>
                                    <strong> Full-Stack Development Capabilities:</strong> From design on the frontend, to logic on the backend, we do it all. Our full-stack development capabilities allow us to make the user experience seamless, powered by a robust, scalable, secure architecture that reflects your growth. Our team includes some of the best website designers in India, ensuring world-class UI/UX in every project.
                                </p>
                                <p><strong>Mobile-Friendly & Responsive:</strong> We ensure your digital existence works wonderfully on any size screen. With responsive design as a requirement, your web solution will look great and work great on smartphones, tablets, and desktops.
                                </p>
                                <p><strong>Technology Consulting & Strategy:</strong> Choosing the right tech stack can be difficult. We help by providing professional insight into frameworks, tools, and architecture to ensure maximum performance, and future proofing your digital assets. This is what makes us one of the best website designing company in India, offering expert advice alongside top-tier execution.
                                </p>
                                <p><strong>API Integration & Automation:</strong> Extend functionality with powerful integrations. We connect your website/application to third-party systems (payment gateways, CRMs, analytics, etc.) and implement automation workflows to optimize efficiency and do away with manual work.
                                </p>
                                <p><strong>Performance Optimization & Security:</strong> Speed and safety are important. We make your web solution faster loading, and better performing, utilizing the latest security protocols.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="services-content bg-gray default-padding">
                <div className="container">
                    <div className="about-style-one-items">
                        <div className="row align-items-center">

                            <div className="col-xl-7 col-lg-6 pl-50 pl-md-15 pl-xs-15">
                                <div className="about-style-one-info">
                                    <div className="content">
                                        <h2 className="title">
                                            Why Choose Us Over the Rest
                                        </h2>
                                        <p>
                                            At Microcode Software we provide custom, scalable solutions with a focus on transparency, reliability and client success. We are proud to be one of the top web designers in India and not just developers, but your partners in the digital space.
                                        </p>
                                        <a class="btn btn-md circle btn-gradient animation mb-20 mb-lg-0" href="/contact" data-discover="true">Contact Us</a>
                                    </div>
                                </div>
                            </div>
                            <div className="col-xl-5 col-lg-6">
                                <div className="thumb-style-one">
                                    <img src="static/img/cloudcomputing/2.webp" alt="Img Not Found" title='Application Development' />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className='services-details-area default-padding'>
                <div className='container'>
                    <div className="process-style-one-items mt-50">
                        <div className="choose-us-one-thumb">
                            <div className="content">
                                <div className="left-info">
                                    <h2 className="title">
                                        Turn Clicks Into Clients With a Site That Performs
                                    </h2>
                                </div>
                                <div className="process-style-one">
                                    <div className="process-style-one-item">
                                        <span>01</span>
                                        <h4>Explore & Discover</h4>
                                        <p>
                                            We understand your business, priorities, and audience so that we can create a distinctive strategic road map.
                                        </p>
                                    </div>
                                    <div className="process-style-one-item">
                                        <span>02</span>
                                        <h4>Design & Construct </h4>
                                        <p>
                                            We design gorgeous, easy-to-use designs, and build a high performing website that represents your brand.
                                        </p>
                                    </div>
                                    <div className="process-style-one-item">
                                        <span>03</span>
                                        <h4>Test, Launch & Ongoing Support</h4>
                                        <p>
                                            We test thoroughly, launch smoothly, and provide ongoing support for your website, so you can focus on your business.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default CloudComputingServiceDetails
